import { render } from "./App.vue?vue&type=template&id=6dc47fdc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6dc47fdc&lang=css"

import exportComponent from "/home/runner/work/demo-webapp/demo-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__